import { useMemo } from "react";

import { useParsedFieldProps } from "./useParsedFieldProps";
import { MATRIX } from "../SchemaTypes";
import Field from "../Field";
import MatrixInput from "../../Input/MatrixInput";

const CheckBoxField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent, label, items, maximumSelectableOptions } = props;

  const itemIds = useMemo(() => items.map(item => item.id), [items]);
  const minimumSelectableOptions = required ? 1 : 0;

  const schema = {
    type: MATRIX,
    parent,
    validations: {
      optionsSelectedPerItem: {
        itemIds,
        minimum: minimumSelectableOptions,
        maximum: maximumSelectableOptions
      }
    }
  };

  return (
    <Field {...fieldProps} schema={schema}>
      <MatrixInput {...inputProps} label={label} />
    </Field>
  );
};

export default CheckBoxField;
